// components/ErrorBox/ErrorBox.js
import React from 'react';

const ErrorBox = ({ 
  message = "خطا در بارگذاری داده‌ها رخ داده است.", 
  onRetry,
  title = "😢 اوه نه!"
}) => {
  return (
    <div style={{
      border: '1px solid #f44336',
      backgroundColor: '#ffebee',
      color: '#c62828',
      padding: '20px',
      borderRadius: '8px',
      maxWidth: '400px',
      margin: '50px auto',
      textAlign: 'center',
      fontFamily: 'sans-serif',
      boxShadow: '0 2px 8px rgba(0,0,0,0.1)'
    }}>
      <h3>{title}</h3>
      <p>{message}</p>
      {onRetry && (
        <button
          onClick={onRetry}
          style={{
            marginTop: '10px',
            backgroundColor: '#c62828',
            color: 'white',
            border: 'none',
            padding: '10px 20px',
            borderRadius: '5px',
            cursor: 'pointer'
          }}
        >
          تلاش مجدد
        </button>
      )}
    </div>
  );
};

export default ErrorBox;